const locale = {
    placeholder: 'هەڵبژاردنی کات',
};
export default locale;
